import React from "react"
import Link from "next/link"
import { getHariseninURL } from "@lib/functions"
import { LinkType } from "@interfaces/misc"

interface BasicLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  linkType?: LinkType
}

export const BasicLink: React.FC<BasicLinkProps> = ({
  children,
  href = "",
  linkType = "internal",
  ...rest
}: BasicLinkProps) => {
  switch (linkType) {
    case "internal":
      return (
        <Link href={href} {...rest}>
          {children}
        </Link>
      )
    case "harisenin":
      return (
        <a href={getHariseninURL(href)} {...rest}>
          {children}
        </a>
      )
    case "external":
      return (
        <a href={href} target="_blank" rel="noopener noreferrer" {...rest}>
          {children}
        </a>
      )
  }
}
